import React, { useRef } from 'react';
import { Box, Grid, Button } from '@material-ui/core';
import { MetaTags } from 'react-meta-tags';
import HeaderLogoBar from "./HeaderLogoBar";
import '../styles/bizofficer.css';
import AlertNoInternet from '../components/AlertNoInternet';
import 'font-awesome/css/font-awesome.min.css';

 


export default function Execute() {
	const internetRef = React.useRef(); 

	const authResult = new URLSearchParams(window.location.search);
	const courseUrl = authResult.get('courseUrl');
	const courseId = authResult.get('courseId');
	const utmSource = authResult.get('utm_source');

	const deviceType = authResult.get('device_type');
  	if(deviceType && deviceType.length>0){
    	localStorage.setItem("deviceType", deviceType);
  	}	

  	const testUid = authResult.get('testUid');	
	let testType = authResult.get('testType');
	if(!testType){
		testType=0;
	}

	// const questionType = authResult.get('questionType');
	// const totalQuestion = authResult.get('totalQuestion');
	// const totalTime = authResult.get('totalTime');
	// const marksCorrectAnswer = authResult.get('marksCorrectAnswer');
	// const marksIncorrectAnswer = authResult.get('marksIncorrectAnswer');
	// const marksNotAttempted = authResult.get('marksNotAttempted');
	// const examType = authResult.get('examType');

	const assessmentMode = authResult.get('assessmentMode');
	const searchFlag = authResult.get('searchFlag');
	const searchQuery = authResult.get('searchQuery');
	const topicId = authResult.get('topicId');
	
	/* RIGHT CLICK DISABLED ON THIS COMPONENT */
	document.addEventListener("contextmenu", (event) => {
		event.preventDefault();
	});

	/* CTRL KEY DISABLED ON THIS COMPONENT */
	document.addEventListener("keydown", function (event) {
		if (event.ctrlKey) {
			event.preventDefault();
		} else if (event.keyCode == 123) { // Prevent F12
			event.preventDefault();
		} else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I        
			event.preventDefault();
		}
	});

	/* REFRESH PAGE DISABLED ON THIS COMPONENT */
	if (window.performance) {
		if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
			document.addEventListener("keydown", function (event) {
				if ((event.which || event.keyCode) == 116 || (event.which || event.keyCode) == 17 || (event.which || event.keyCode) == 16 || (event.which || event.keyCode) == 82) {
					// Pressing F5 or Ctrl+R
					event.preventDefault();
				}
			});
		}

	}

	function startTest() { 
		let qryStr='';
		if(courseUrl && courseUrl.length>0){
			qryStr+='&courseUrl='+courseUrl;
		}
		if(courseId && courseId>0){
			qryStr+='&courseId='+courseId;
		}
		if(utmSource && utmSource.length>0){
			qryStr+='&utm_source='+utmSource;
		}
		if(testUid && testUid.length>0){
			qryStr+='&testUid='+testUid;
		}
		
		// if(questionType && questionType.length>0){
		// 	qryStr+='&questionType='+questionType;
		// }
		// if(totalQuestion && totalQuestion>0){
		// 	qryStr+='&totalQuestion='+totalQuestion;
		// }
		// if(totalTime && totalTime>0){
		// 	qryStr+='&totalTime='+totalTime;
		// }
		// if(marksCorrectAnswer && marksCorrectAnswer>-100){
		// 	qryStr+='&marksCorrectAnswer='+marksCorrectAnswer;
		// }
		// if(marksIncorrectAnswer && marksIncorrectAnswer>-100){
		// 	qryStr+='&marksIncorrectAnswer='+marksIncorrectAnswer;
		// }
		// if(marksNotAttempted && marksNotAttempted>-100){
		// 	qryStr+='&marksNotAttempted='+marksNotAttempted;
		// }		
		// if(examType && examType.length>0){
		// 	qryStr+='&examType='+examType;
		// }
		if(assessmentMode && assessmentMode.length>0){
			qryStr+='&assessmentMode='+assessmentMode;
		}
		if(searchFlag && searchFlag.length>0){
			qryStr+='&searchFlag='+searchFlag;
		}
		if(searchQuery && searchQuery.length>0){
			qryStr+='&searchQuery='+searchQuery;
		}
		if(topicId && topicId>0){
			qryStr+='&topicId='+topicId;
		}
		let testTypez = testType;
		if(!testTypez){
			testTypez = 0;
		}
		window.location.href='guest-testsimulator?testType='+testTypez+qryStr;

	}

	

	return (
		<div>
			<MetaTags>
				<title>Guest Test Begin</title>
				<meta name="description" content="Guest Test Begin" />
			</MetaTags>
			{!window.navigator.onLine ?
				<div className='netBar' >Alert: It seems, you are not connected to the internet.</div>
				: null}
			 
			<HeaderLogoBar />
				
				
			<Box style={{ marginTop: 80, marginLeft: 20, marginRight: 20 }}>

		  			<Grid item   md={12} xs={12} className="test-instructions" >
								<div className="btmbdrgry"><h3>Instructions</h3></div>
								{(testType && testType==1 && assessmentMode && assessmentMode=='beginner')?
								<p>
									Smart Learning - Practice Mode <br/>
									Hey there! 👋 <br/>
									Welcome to Smart Learning – Practice Mode — your personal playground to learn by doing.
									<br/><br/>
									🧠 What’s the goal?<br/>
									Not to score high —<br/>
									but to spot knowledge gaps and fix them through real practice.
									<br/><br/>
									📌 How to Use This Session:<br/>
									✅ Attempt each question sincerely.
									<br/><br/>
									🛑 Don’t worry if you're stuck or make mistakes —<br/>
									That’s where the real learning begins.
									<br/><br/>
									📖 Use your:<br/>
									Books & Notes<br/>
									Teachers<br/>
									Internet<br/>
									Tony AI (your learning assistant!) <br/><br/>

									🤖 Tony AI has your back!<br/>
									Ask Tony for:<br/>

									Hints & concepts<br/>

									Step-by-step explanations<br/>

									Tips to approach similar problems<br/>

									He’s here to support your learning journey.<br/><br/>

									⏱ No Rush, No Timer<br/>
									Take it slow. Think deeply.<br/>
									Smart Learning – Practice Mode is your safe space to build strong concepts.
									<br/><br/>
									🚀 Ready to explore?<br/>
									Tap Start Practice and let Smart Learning guide you to mastery!
									
								</p>
								:(testType && testType==1 && assessmentMode && assessmentMode=='advance')?
								<p>
									🏁 Smart Learning - Competitive Mode<br/>
									Welcome to Smart Learning - Competitive Mode 💪<br/>
									Time to shift gears from learning to performing!<br/>
									<br/>
									🎯 What's the goal?<br/>
									Now that you've practiced and filled your knowledge gaps, this mode helps you:
									<br/>
									Improve speed
									<br/>
									Boost accuracy
									<br/>
									Strengthen focus under time pressure
									<br/><br/>
									⏱ What's different here?<br/>
									This session is timed — like a race against the clock.
									<br/>
									No hints, no AI help. You're on your own now.
									<br/><br/>
									Not an exam simulation!<br/>
									Questions here vary in difficulty to test how deep and complete your topic knowledge really is.
									<br/><br/>
									🧠 Why this matters:<br/>
									Think of this as mental training.<br/>
									You're not just answering — you're learning to think fast, stay sharp, and stay accurate.
									<br/><br/>
									🔁 Practice Mode → Competitive Mode → Exam Room
									Mastery starts with understanding.<br/>
									This mode pushes you to apply it — fast and fearlessly.
									<br/><br/>
									🚀 Ready to challenge yourself?<br/>
									Tap Start Competitive Mode and prove what you've learned!

								</p>
								:<p>
									<ol>
										<li>The clock has been set at server and count down timer at the top right corner of the screen will display left out time to closure from where you can monitor time you have to complete the exam.</li>
										<li>Click answer option buttons to select your answer.</li>
										<li>To change an answer, simply click the desired option button.</li>
										<li>Click on RESET button to deselect a chosen answer.</li>
										<li>Click on SAVE & NEXT to save the answer before moving to the next question. The next question will automatically be displayed.</li>
										<li>Click on SKIP to move to the next question without saving the current question.</li>
										<li>Click on MARK FOR REVIEW to review your answer at later stage.</li>
										<li>Make sure you click on SAVE & NEXT button everytime you want to save your answer.</li>
										<li>To go to a question, click on the question number on the right side of the screen.</li>
										<li>The color coded diagram on the right side of the screen shows the status of the questions												
												<div>
													<div><div className="qbg-not-visited-ins" style={{background:"url('/not-visited.png')"}} >2</div> you have not visited question no 2. </div>
													<div className="qbg-ins-label" ><div className="qbg-visited-ins" style={{background:"url('/not-answered.png')"}} >3</div> you have not answered question no 3.</div>
													<div className="qbg-ins-label" ><div className="qbg-visited-ins" style={{background:"url('/answered.png')"}} >4</div> you have answered question no 4.</div>
													<div className="qbg-ins-label" ><div className="qbg-visited-ins" style={{background:"url('/review.png')"}} >5</div> you have marked the question no. 5 for review.</div>
													<div className="qbg-ins-label" ><div className="qbg-visited-ins" style={{background:"url('/answered-review.png')"}}  >6</div> you have answered & marked for review of question no. 6</div>
												</div>												
										</li>								
										<li className="clr">Candidate will be allowed to Shuffle between sections and questions anytime during the examination as per their convenience.</li>
										<li>Candidate can change their response of attempted answers anytime during the examination slot time by clicking another answer which candidates wants to change.</li>
										<li>All the answered questions(saved or marked) will be considered for calculating the final score.</li>
										<li className="redboldtxt" >Do Not PRESS any keyboard key once the exam is started.This will LOCK your exam. You can connect with the exam invigilator to unlock and continue giving the exam.</li>
										<li className="redboldtxt" >Do Not CLICK on the SUBMIT Button unless you have completed the exam.In case you click SUBMIT button, you will not be permitted to continue.</li>
									</ol>
								</p>
							}	

					</Grid>

					<div style={{marginBottom:50}} >	
						<Button title="Start Test" variant="contained" onClick={() => { startTest() }} color="primary" >Start Test</Button>
					</div>
			</Box>

			
			
			<AlertNoInternet ref={internetRef} />

				
				

		</div>
	);

}




